
















































import { Component, Vue } from 'vue-property-decorator';
import { Organisation } from '@/api';

import authModule from '@/store/Auth';

import TabLayout from '@/components/common/TabLayout.vue';
import TabLayoutItem from '@/components/common/TabLayoutItem.vue';
import OrganisationDetails from '@/components/dashboard/OrganisationDetails.vue';
import OrganisationUsers from '@/components/dashboard/OrganisationUsers.vue';

@Component({
  components: {
    TabLayout,
    TabLayoutItem,
    OrganisationDetails,
    OrganisationUsers,
  },
})
export default class ManageOrganisation extends Vue {
  item: Organisation | null = null;

  activeTab = 0;

  get activeOrg() {
    return authModule.activeOrganisation
      ? authModule.activeOrganisation.organisation
      : null;
  }

  get isUser() {
    return authModule.activeOrganisation ? authModule.isUser : false;
  }

  organisationUpdated(organisation: Organisation) {
    this.item = organisation;
  }

  getTabIndexFromHash(): number {
    const { hash } = this.$route;
    switch (hash) {
      case '#users':
        return 1;
      default:
        return 0;
    }
  }

  mounted() {
    this.item = this.activeOrg;
    this.activeTab = this.getTabIndexFromHash();
  }
}
